// The columns the 1-2-1's pages read (data.js), in 1 place, so the tests replay exactly these
// (tests/e2e/fixtures/mentorship/record-mentorship.sql reads the same, and mentorship.spec.js refuses
// any other). Pure: no imports.
export const SPACE_COLUMNS = 'id, product_id, client_person_id, booking_url, opened_at, ended_at'
export const SESSION_COLUMNS = 'id, space_id, number, title, starts_at, duration_minutes, zoom_join_url'
export const NOTE_COLUMNS = 'session_id, recording_url, duration_seconds, notes, shown_at'
export const ACTION_COLUMNS = 'id, space_id, agreed_session_id, body, sort_order, done_at, created_at'
export const FILE_COLUMNS = 'id, space_id, direction, file_name, content_type, size_bytes, created_at'
// the client's own name and email, for Adam's view (the client's own come from the member's row)
export const PERSON_COLUMNS = 'id, first_name, full_name, email'
// the client's place in each session's recording (hub.client_recording_progress, stage 5)
export const PROGRESS_COLUMNS = 'session_id, position_seconds, furthest_seconds, seconds_watched, watched_at, last_played_at'
